module.exports = __webpack_public_path__ + "static/assets/0f3aeb82f652b7b9c5b586cc50d052e4.png";